"use client" 
import { useEffect, useState, useRef, use } from "react";
import axios from "axios";

import { useParams } from "next/navigation";
import { formatPhoneNumber, humanizeString, standardizeFileName } from "@/utils/frontend/stringOps.js";
import ModalOverlay from "../../Atoms/ModalOverlay.js";
import ModalHeader from "./ModalHeader.js";
import ModalFooter from "./ModalFooter.js";
import RadioButton from "../../Atoms/Buttons/RadioButton.js";
import FormSubHeading from "../../Atoms/FormElements/FormSubHeading.js";
import RadioButton_1 from "../../Atoms/Buttons/RadioButton_1.js";
import LocationSelect from "../../Atoms/Select/LocationSelect.js";
import { getCookies } from "@/utils/frontend/cookieOps.js";
import InputText from "@/components/Atoms/inputText.js";
import TextEditor from "../TextEditor.js";
import TagsAssociationSelect from "@/components/Atoms/Select/TagsAssociationSelect.js";
import DatePicker from "@/components/Atoms/FormElements/DatePicker.js";
import SectorSelect from "@/components/Atoms/Select/SectorSelect.js";
import FileUploadDragAndDrop from "@/components/Atoms/FileUploadDragAndDrop.js";
import Link from "next/link.js";
import { useRouter } from "next/navigation.js";
import Alert from "@/components/Atoms/Alerts/Alert.js";
import checkSignInStatus from "@/utils/frontend/checkSignInStatus.js";
import EULAModal from "./EULAModal.js";
import { IndigoButton } from "@/components/Atoms/Buttons/ColorButtons.js";
import Hint from "@/components/Atoms/Alerts/Hint.js";
import { validateRequiredFieldsManually } from "@/utils/frontend/validateRequiredFieldsManually.js";
// import validateRequiredFields from "@/utils/frontend/validateRequiredFields.js";


const CandidateModal =  ({
  job, 
  state,
  callback,
  target,
  organizationPreferences,
  modalHeaderCaption,
  lang,
  parentComponent,
  parentPath
}) => {
  // console.log("CANDIDATE MODAL STATE", state)

  const router = useRouter()
// const user = getCookies().user
const [data, setData] = useState(null) //REMOVE THE INITIAL STATE ARG 
const [selectedTags, setSelectedTags] = useState(null)
const [tagsTable, setTagsTable] = useState(null)
const [missingFields, setMissingFields] = useState({})
const [modalOpen, setModalOpen] = useState(false)
const [url, setUrl] = useState(null)
const [userIsSignedIn, setUserIsSignedIn] = useState(false)
const [success, setSuccess] = useState(false)
const [error, setError] = useState(false)
const [loading, setLoading] = useState(false)
const [EULAModalOpen, setEULAModalOpen] = useState(false)
const [hint, setHint] = useState(null)
const [candidateFromCookies, setCandidateFromCookies] = useState(getCookies().user) 
// console.log("TARGET", target)

  
// console.log(`Job@CandidateModal`, job)



useEffect(() => {

  setUrl({
    pathname: window.location.pathname.split(`/${lang}/`)[1] || '',
    search: window.location.search
  })

  const getData = async () => {
    setModalOpen(state.candidateModalOpen)
    try {
      let apiUrl = `/api/tags/`;
      let response = await fetch(apiUrl, {
        method: `GET`,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
        credentials: "include", // If you are sending cookies with a cross-origin request, use 'include'
      });

      response = await response.json();

      setTagsTable(response.data);
   //    setLoading(false)
    } catch (error) {
      console.log("error", error);
    }

  };



 
    const verifyUser = async () => {
        try {
            setUserIsSignedIn(await checkSignInStatus('CANDIDATE', 'include', undefined, undefined));
        } catch (error) {
            console.error('Error checking sign-in status:', error);
        } finally {
            setLoading(false);
        }
    };
    verifyUser(); 


  
  getData();


}, [state.candidateModalOpen]);




  const handleChildCallback = (cb) => {
        // if (cb.communication_language) {setData({...data, communication_language: cb.communication_language})}

    console.log(cb)
    // callback.stage && setData({ ...data, person_stage: callback.stage });

      if (cb.action === 'fileUpload') {setData({...data, file_name: standardizeFileName(cb.file.name), file_extension: cb.file.name.split('.')[1], file: cb.file})}
      // if (cb.action === 'fileCategorySelected') {setData({...data, file_category: cb.fileCategory});}
  };

  const handleTagsCallback = cb => {
    console.log('cbTags', cb)
    setSelectedTags(cb.tags.newTags)
    setData({...data, tags: cb.tags.newTags.map(tag=>tag.tag_name).join(', ')})
  }


  const handleRadioButtonCallback = cb => {
    console.log('callback@JobModal', cb)
    if (cb.job_type) {setData({...data, job_type: cb.job_type})}
    if (cb.job_is_published) {setData({...data, job_is_published: cb.job_is_published})} // this is a str, not a Bool, it's converted to Bool in backend (post / put request)
    if (cb.job_status) {setData({...data, job_status: cb.job_status})}
    console.log(data)
    // callback({action: "presetFilterApplied", presetFilterQuery: cb})
  }



  const handleChange = (x) => {
    // setData({
    //   ...data,
    //   [event.target?.name]: event.target?.value,
    // });
    // console.log(data);
      // if phone number, allow numbers only
  if (x.target.name === 'phone_number') {
    setData({...data, [x.target.name]: formatPhoneNumber(x.target.value)});
    x.target.value.length > 1 && setMissingFields({...missingFields, [x.target.name]: false})
  }
  else {
  setData({...data, [x.target.name]: x.target.value});
    x.target.value.length > 1 && setMissingFields({...missingFields, [x.target.name]: false})
  }
  };

  // const validateRequiredFields = (postPutData, isRegistering) => {
  //   let obj = {};
  
  //   // Validate required fields one by one and add missing fields to obj
  //   if (!postPutData.first_name) {
  //     obj.first_name = true;
  //   }
  //   if (!postPutData.last_name) {
  //     obj.last_name = true;
  //   }
  //   if (!postPutData.email_address) {
  //     obj.email_address = true;
  //   }
  
  //   // Additional fields if user is registering
  //   if (isRegistering) {
  //     if (!postPutData.user_eula) {
  //       obj.user_eula = true;
  //     }
  //     if (!postPutData.user_password) {
  //       obj.user_password = true;
  //     }
  //   }
  
  //   return obj;
  // };

  

const postPutData = {
  first_name: data?.first_name || candidateFromCookies?.user_first_name,
  last_name: data?.last_name || candidateFromCookies?.user_last_name,
  phone_number: data?.phone_number || candidateFromCookies?.user_phone_number,
  email_address: data?.email_address || candidateFromCookies?.user_email_address,
  salary: data?.salary,
  access_level: data?.talent_access_level,
  message: data?.message,
  location: data?.location,
  tags: data?.tags,
  lang: lang,
  file: data?.file || null,
  file_name: data?.file_name,
  file_extension: data?.file_extension,
  user_eula: data?.user_accepted_eula,
  user_password: data?.user_password,
  user_password_repeat: data?.user_password_repeat
}




const handleSubmit = async (registering) => {


  console.log("postPutData", postPutData)
  const formData = new FormData();
  // Append all other data to the FormData object
  formData.append("first_name", postPutData.first_name);
  formData.append("last_name", postPutData.last_name);
  formData.append("phone_number", postPutData.phone_number);
  formData.append("email_address", postPutData.email_address);
  formData.append("salary", postPutData.salary);
  formData.append("access_level", postPutData.access_level || 'STANDARD');
  formData.append("location", postPutData.location);
  formData.append("message", postPutData.message);
  formData.append("lang", postPutData.lang);
  formData.append("tags", postPutData.tags);
  formData.append("parent_component", parentComponent)
  formData.append("parent_path", parentPath);
  formData.append("parent_job", job ? JSON.stringify(job) : null)
  formData.append("registered_user_data", getCookies()?.user ? JSON.stringify(getCookies()?.user) : null)

  if (registering) {
    formData.append("user_password", postPutData.user_password)
    formData.append("user_eula", postPutData.user_eula)
  }
  // Append file if it exists
  if (postPutData.file) {
    formData.append("file", postPutData.file, postPutData.file_name);
    formData.append("file_name", postPutData.file_name),
    formData.append("file_extension", postPutData.file_extension)
  }

    // Validate required fields and set missing fields state
    const tempMissingFields = validateRequiredFieldsManually(postPutData, registering, ['first_name', 'last_name', 'phone_number', 'email_address'])
    setMissingFields(tempMissingFields);
  
    // Check if there are any missing fields
    if (Object.values(tempMissingFields).includes(true)) {
      const missingFieldsList = Object.keys(tempMissingFields)
        .filter(key => tempMissingFields[key] === true)
        .join(', ');
      setError({ 
        message: lang === 'fr' 
          ? `Champs obligatoires manquants: ${missingFieldsList}` 
          : `Missing Required Fields: ${missingFieldsList}` 
      });
      return false;
    }
  


   
  try {
    let apiUrl = `/api/candidatures/`;
    let response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include', // Keep this if you need cookies sent
      body: formData, // Send formData object
    });

    let responseJSON = await response.json();

    console.log("Response: ", responseJSON)
    if (response.status===200){
      let successMessage; 
      if (registering){
        successMessage = lang === 'fr' ?  "Votre compte a été créé et candidature soumise." : "Your account has been created and candidature submitted."
      }
      else {
        successMessage = lang === 'fr' ? "Votre candidature a été soumise." : "Your candidature has been submitted."
      }
      setSuccess({ message: successMessage });
      // document.cookie = `token=${JSON.stringify(await responseJSON.token)}`;
      console.log(`resJSON`, responseJSON)
      if (registering){
        document.cookie = `user=${JSON.stringify(await responseJSON.user)}; path=/;`;
      }
      // document.cookie = `organization=${JSON.stringify(await responseJSON.organization)}; path=/;`;
          // window.location.href = `../workspace/`
      }
    else {
      // duplicate entry of unique value
      if (responseJSON.error.original?.errno === 1062) { 
        let errKeys = Object.keys(responseJSON.error.fields)
        let errValues = Object.values(responseJSON.error.fields)
        setError({message: lang === 'fr' ? `${humanizeString(errKeys.toString())} existe déjà.` : `${humanizeString(errKeys.toString())} already exists.`})
        setMissingFields({...missingFields,  [errKeys]: true})
      }
      else {
        setError({message: lang === 'fr' ? `Erreur: ${response.status} - ${responseJSON.error}` : `Error: ${response.status} - ${responseJSON.error}`})
      }
    }





    // setSuccess({message: lang === 'fr' ? "Votre candidature a été soumise." : "Your candidature has been submitted."})

  } catch (error) {
    console.log('error', error);
    setError({message: lang === 'fr' ? `Votre candidature n'a pas été soumise\n${error}` : `Your candidature has not been submitted.\n${error}`})
  } 

};



const handleCheckboxChange = x => { 
  if (x.target.checked) {
    setMissingFields({...missingFields, user_eula: false});
    setData({...data, user_accepted_eula: true})
  }
  else {
    setData({...data, user_accepted_eula: false})
  }
 
}



  return (
    <>
    <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>

    <Hint state={{hint:hint, setHint: setHint}} message={hint?.message}/>

    
    {/* <EULAModal lang={lang} state={{EULAModalOpen: EULAModalOpen, setEULAModalOpen: setEULAModalOpen}} callback={(cb)=>{cb.user_accepted_eula ? setData({...data, user_accepted_eula: true}) : setData({...data, user_accepted_eula: false})}}/> */}

{/* <div class="right-0 top-0 overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform translate-x-full"> */}
<div
  className={`right-0 top-0 overflow-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform ${
    modalOpen === true ? 'translate-x-0' : 'translate-x-full'
  }`}
>
            <div>
              {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

              <div className="mt-0 absolute right-0 top-0 min-h-screen w-11/12 lg:w-1/3">
                {/*content*/}
                <div className="border-0 rounded-l-3xl min-h-screen shadow-none relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900">
                  {/*header*/}
                  {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}
    
                  <ModalHeader caption={modalHeaderCaption} closeOnClickMethod={() => {
                    // setModalOpen(false); router.push(`passive`)
                    setModalOpen(false); 
                    router.push('?')
                    }}/>

   

   
                  <div className="relative p-6 flex-auto text-left">
                  
                    <div className="my-4 text-slate-500 text-lg text-gray-900 dark:text-gray-100">
                    {parentComponent === 'PASSIVE' && <div className="text-sm leading-1 my-6">
                    {lang === 'fr' ? <span>Veuillez remplir vos coordonnées ainsi que les outils techniques / frameworks et langages de programmation avec lesquels vous seriez intéressé à travailler. <strong>Faisons bouger les choses !</strong></span> : 
                    <span>Please fill out your contact information along with the technical tools / frameworks and programming languages you would be interested in working with. <strong>Let's make something happen!</strong></span>}
                    </div>}

                    {parentComponent === 'JOB' && <div className="text-sm leading-1 my-6">
                    {lang === 'fr' ? <span><strong>Merci pour votre intérêt ! </strong>Veuillez remplir ce court formulaire et nous allons entrer en contact avec vous sous-peu.</span> : 
                    <span><strong>Glad you found a potential match! </strong>Please fill out the short form below and we will be touching bases shortly.</span>}
                    </div>}



                      <div className="flex grid lg:grid-cols-12 gap-1 align-middle mb-2">
                      <div className="lg:col-span-6 w-full">

                      <InputText 
                        name='first_name' 
                        id="first_name" 
                        required={true} 
                        error={missingFields?.first_name ? true : false} 
                        data={{type: 'text', id:'first_name', value: postPutData.first_name || candidateFromCookies?.user_first_name  , onChange: x=>handleChange(x), label: `${lang === 'fr' ? 'Votre Prénom' : 'Your First Name'}`}}/>
                        </div>       
                        <div className="lg:col-span-6 w-full">
                        <InputText 
                        error={missingFields?.last_name ? true : false} 
                        name='last_name' data={{type: 'text', id:'last_name',  value: postPutData.last_name || candidateFromCookies?.user_last_name, onChange: x=>handleChange(x), label: `${lang === 'fr' ? 'Votre Nom de Famille' : 'Your Last Name'}`}}/>
                      </div>
                      </div>


                      <div className="col-span-4 space-y-2">

                      <InputText 
                      error={missingFields?.phone_number ? true : false} 
                      name='phone_number' 
                      data={{type: 'text', id:'phone_number', value: postPutData.phone_number || candidateFromCookies?.user_phone_number , onChange: x=>handleChange(x), label: `${lang === 'fr' ? 'Votre Numéro de Téléphone' : 'Your Phone Number'}`}}
                      />
                      
                      <InputText 
                      error={missingFields?.email_address ? true : false}  
                      name='email_address' 
                      data={{type: 'text', id:'email_address', value: postPutData.email_address || candidateFromCookies?.user_email_address, onChange: x=>handleChange(x), label: `${lang === 'fr' ? 'Votre Adresse Courriel' : 'Your Email Address'}`}}
                      />

                      {parentComponent === 'PASSIVE' && <TagsAssociationSelect 
                        placeholder={lang === 'fr' ? "Vos Compétences" : 'Your Skillset'}
                        tagsTable={tagsTable}
                        callback={handleTagsCallback} 
                          target={target}/>}
                      
              <LocationSelect
              value = {postPutData.location ? {value: postPutData.location, label: postPutData.location} : ''}
                              placeholder={lang === 'fr' ? "Votre Localisation" : 'Your Location'}
                              onChange={(selection) => {
                                setData({ ...data, location: selection ? selection.value : null });
                                console.log('selected', selection);
                              }}
                            />
                       



              {parentComponent === 'PASSIVE' && 
              <>
              <InputText name='salary' data={{type: 'text', id:'salary',  value: postPutData.salary, onChange: handleChange, label: lang === 'fr' ? `Vos Prétentions Salariales` : `Your Salary Expectations`}}/>
              <RadioButton_1
                          name="talentIsPublishedRadioSwitch"
                          value1={"PRIVATE"}
                          value2={"STANDARD"}
                          value3={"PUBLIC"}
                          caption1={<><i className="mr-1 fa-solid fa-lock text-gray-400 text-base"/>{lang === 'fr' ? 'Confidentiel' : 'Private'}</>}
                          caption2={<><i className="mr-1 fa-solid fa-unlock text-gray-400 text-base"/>Standard</>}
                          caption3={<><i className="mr-1 fa-solid fa-lock-open text-gray-400 text-base"></i>Public</>}
                          defaultChecked={"STANDARD"}
                          callback={(x)=>setData({...data, talent_access_level: x.talent_access_level})}
                          callbackObjectKey={'talent_access_level'}
                        />
              </>

              }
              

<textarea
                rows="20"
                className="w-full dark:bg-inherit mb-4 appearance-none border border-gray-500 dark:border-gray-600 rounded-lg py-2 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm"
                id="message"
                value={postPutData.message}
                onChange={handleChange}
                name="message"
                placeholder={lang === 'fr' ? `Message Optionnel...` : `Optional Message...`}
              />
              <FileUploadDragAndDrop lang={lang} fileName={data?.file_name || ''} callback={handleChildCallback}/>

                      </div>

<br/><br/>



{/* <div className={`${missingFields?.user_eula ? 'border p-2 rounded-md border-red-500' : false} flex items-center text-xs dark:text-gray-400`}>

<input name="user_eula" id="user_eula" required={true} type="checkbox" checked={data?.user_accepted_eula} onChange={(x)=>handleCheckboxChange(x)} className={`mr-2`}/>
<span className="mr-1">{lang === 'fr' ? "J'ai lu et accepte le " : 'I have read and accept the'}</span>
<span>
<Link href={`/${lang}/candidates/user-agreement`} target="_blank" className="text-indigo-700 hover:underline dark:text-indigo-500">
{lang === 'fr' ? "Contrat de licence et conditions d'utilisation" : " Terms and License Agreement"}
</Link>
</span>
</div> */}


{!userIsSignedIn &&
<div className="text-sm mb-20 flex grid xl:grid-cols-4 gap-1 align-middle">
  <div className="xl:col-span-2">
  <InputText 
          onFocus={()=>setHint({message: lang === 'fr' ? 'Le mot de passe doit contenir plus de 7 caractères.' : 'The password must contain more than 7 characters.'})}
          onBlur={()=>setHint(null)}
          name='user_password'
          required={true}
          data={{
            id: 'user_password',
            onChange:(x)=>{handleChange(x)},
            label: lang === 'fr' ? 'Choisissez un Mot de Passe' : 'Choose a Password',
            darkBGValue: '900',
            value: data?.user_password,
            type: 'password',
            }}
            error={missingFields?.user_password ? true : false}/>
  </div>
  <div className="xl:col-span-2">
  <InputText 
          onBlur={()=>setHint(null)}
          name='user_password_repeat'
          required={true}
          data={{
            id: 'user_password_repeat',
            onChange:(x)=>{handleChange(x); x.target?.value !== data.user_password ? setHint({message: lang === 'fr' ? 'Les mots de passe ne corréspondent pas.' : 'Passwords do not match.'}) : setHint(null)},
            label: lang === 'fr' ? 'Repetez le Mot de Passe' : 'Repeat Password',
            darkBGValue: '900',
            value: data?.user_password_repeat,
            type: 'password',
            }}
            error={missingFields?.user_password_repeat ? true : false}
            />
  </div>
  <div className={`mt-2 ml-1 xl:col-span-4 ${missingFields?.user_eula ? 'border p-2 rounded-md border-red-500' : false} flex items-center text-xs dark:text-gray-400`}>
<input name="user_eula" id="user_eula" required={true} type="checkbox" checked={data?.user_accepted_eula} onChange={(x)=>handleCheckboxChange(x)} className={`mr-2`}/>
<span className="mr-1">{lang === 'fr' ? "J'ai lu et accepte le " : 'I have read and accept the'}</span>
<span>
<Link href={`/${lang}/talent/user-agreement`} target="_blank" className="text-indigo-700 hover:underline dark:text-indigo-500">
{lang === 'fr' ? "Contrat de licence et conditions d'utilisation" : " Terms and License Agreement"}
</Link>
</span>
</div>
  {/* <div className="xl:col-span-4 mt-2 items-end ">
  <IndigoButton
              // loading={loading}
              // onMouseDown={saveOnClickMethod1}
              // onClick={closeOnClickMethod}
              caption={lang === 'fr' ? "S'inscrire et Postuler" : "Register & Apply"}
            />
  </div>
   */}
  </div>
}
                    </div>
                    
                  </div>

                  {/*footer*/}




                  <ModalFooter closeOnClickMethod={() => {
                    setModalOpen(false); 
                    router.push('?')
                    // window.location.search = ""

                  // window.location.href="?application=false"
                }} 
                missingRequiredFields={Object.values(missingFields).includes(true)}
                saveOnClickMethod1={()=>handleSubmit(false)} 
                saveOnClickMethod2={()=>handleSubmit(true)} 
                submitButtonCaption1={lang === 'fr' ? 'Postuler' : 'Apply'}
                submitButtonCaption2={!userIsSignedIn ? lang === 'fr' ? "Créer Profil et Postuler" : 'Save Profile & Apply' : ''}
                cancelButtonCaption={lang === 'fr' ? 'Annuler' : 'Cancel'}
                  state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
                  />

                </div>
              </div>
            </div>
          </div>

          {modalOpen && <ModalOverlay/>}
        </>

  );
};

export default CandidateModal;
